export default function fileApiSupport() {
    return !!(window.File && window.FileList);
}
